var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TitledCard',{attrs:{"title":_vm.$t('vorstossCard')},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.openVorstossDialog}},[_vm._v(_vm._s(_vm.$t('newVorstossButton')))])]},proxy:true}])},[_c('VorstossDialog',{ref:"vorstossDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }